import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastSuccess } from '@/helpers';
import { useApiError } from '@/modules/common/hooks/use-api-error';

import { retryBill } from '../api';
import { BILLS_QUERY_KEY } from './use-bills';

export const useRetryBill = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('authenticated.bills');
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: (billId: number) => retryBill(billId),
    onSuccess: async () => {
      // Invalidate bills queries to refetch with updated status
      await queryClient.invalidateQueries({ queryKey: [BILLS_QUERY_KEY] });
      displayToastSuccess(t('toasts.retrySuccess'));
      onSuccess?.();
    },
    onError: error =>
      displayToastErrorFromApiWithFallback(error, 'authenticated.bills:toasts.retryError'),
  });
};
